import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A vertical drag handle that resizes an adjacent dock column and reports the
 * clamped width through `setWidth`. `invert` is for a right-edge dock, whose
 * handle sits on its left edge, so a drag to the left widens it.
 */
import { useRef } from 'react';
import styles from './Splitter.module.css';
export function Splitter({ width, setWidth, min = 180, max = 560, invert = false, label, className, }) {
    const drag = useRef({ startX: 0, startW: 0, active: false });
    const onPointerDown = (e) => {
        drag.current = { startX: e.clientX, startW: width, active: true };
        // Pointer capture keeps the drag tracking off the thin handle. The test DOM
        // lacks it, hence the guard.
        try {
            e.currentTarget.setPointerCapture(e.pointerId);
        }
        catch {
            /* unsupported (test env) */
        }
        e.preventDefault();
    };
    const onPointerMove = (e) => {
        if (!drag.current.active)
            return;
        const delta = e.clientX - drag.current.startX;
        const next = drag.current.startW + (invert ? -delta : delta);
        setWidth(Math.max(min, Math.min(max, next)));
    };
    const endDrag = (e) => {
        if (!drag.current.active)
            return;
        drag.current.active = false;
        try {
            e.currentTarget.releasePointerCapture(e.pointerId);
        }
        catch {
            /* unsupported (test env) */
        }
    };
    return (_jsx("div", { role: "separator", "aria-orientation": "vertical", "aria-label": label, className: className ? `${styles.splitter} ${className}` : styles.splitter, onPointerDown: onPointerDown, onPointerMove: onPointerMove, onPointerUp: endDrag, onPointerCancel: endDrag }));
}
//# sourceMappingURL=Splitter.js.map